import angular from 'angular';
import { find, map, filter } from 'lodash';

import { getErrorMessage } from 'application/util/error.util';
import { getMaxNumberOfCollaborators } from 'common/util/plan.util';

import './collaborator-manage-modal.style.sass';
import template from './collaborator-manage-modal.tpl.pug';

class CollaboratorManageModalController {
    /* @ngInject */
    constructor($q, modalService, sessionService, collaboratorService, notificationService) {
        this.$q = $q;
        this.modalService = modalService;
        this.sessionService = sessionService;
        this.collaboratorService = collaboratorService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.loading = true;

        this.load().finally(() => {
            this.initialCollaborators = map(this.collaborators, (collaborator) => angular.merge({}, collaborator));
            this.loading = false;
        });
    }

    load() {
        return this.$q.all([
            this.loadUser(),
            this.loadCollaborators()
        ]).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to load your data. Please try again later.`));
        });
    }

    loadUser() {
        return this.sessionService.initialize().then((data) => {
            this.maxCollaboratorCount = getMaxNumberOfCollaborators(data ? data.plan : null);
            this.user = data.user;
        }).catch((result) => {
            this.maxCollaboratorCount = 0;
            this.user = {};

            return this.$q.reject(result || `We were not able to load your user data. Please try again later.`);
        });
    }

    loadCollaborators() {
        return this.collaboratorService.getAll().then((collaborators) => {
            this.collaborators = collaborators;
        }).catch((result) => {
            this.collaborators = [];

            return this.$q.reject(result || `We were not able to retrieve the collaborators. Please try again later.`);
        });
    }

    get isEmpty() {
        return this.collaborators && this.initialCollaborators && this.collaborators.length < 1 && this.initialCollaborators.length < 1;
    }

    get canInvite() {
        return this.collaborators && this.maxCollaboratorCount > 0 && this.collaborators.length < this.maxCollaboratorCount;
    }

    get isAtMaxCollaborators() {
        return !this.loading
            && this.maxCollaboratorCount > 0
            && this.collaborators
            && this.collaborators.length >= this.maxCollaboratorCount;
    }

    openInviteMembersModal() {
        this.loading = true;

        return this.modalService.open({
            component: 'dbACollaboratorInviteModal',
            bindings: {
                emails: map(this.collaborators, (collaborator) => collaborator.email),
                user: this.user.email
            }
        }).then((email) => {
            return this.add({
                email
            });
        }).catch(() => null).finally(() => this.loading = false);
    }

    add(collaborator) {
        return this.collaboratorService.create(collaborator).then(() => {
            return this.load();
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to add ${collaborator.name} to the collaborators. Please try again later.`));
            return this.$q.reject(result);
        });
    }

    promptToDelete(collaborator) {
        this.loading = true;

        return this.modalService.open({
            component: 'dbAConfirmModal',
            bindings: {
                title: 'Delete collaborator',
                message: [
                    `This collaborator will be removed from all the teams he has been assigned to. Altough you can re-invite him back anytime.`,
                    `Are you still sure about it?`
                ],
                onClose: this.delete.bind(this, collaborator)
            }
        }).catch(() => null).finally(() => this.loading = false);
    }

    delete(collaborator) {
        return this.collaboratorService.delete(collaborator).then(() => {
            return this.load();
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to remove ${collaborator.name} from the collaborators. Please try again later.`));
            return this.$q.reject(result);
        });
    }

    getAddedCollaborators() {
        return filter(this.collaborators, (collaborator) => {
            return !find(this.initialCollaborators, (initial) => collaborator.email === initial.email);
        });
    }

    close() {
        return this.onClose({
            data: map(this.getAddedCollaborators(), (collaborator) => collaborator.email)
        });
    }
}

export default {
    selector: 'dbACollaboratorManageModal',
    template: template(),
    controller: CollaboratorManageModalController,
    bindings: {
        onDismiss: '&',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/collaborator-manage-modal/collaborator-manage-modal.cmpt.js